import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
  Toolbar,
  Sort,
  Edit,
  Resize,
  RowDD,
} from "@syncfusion/ej2-react-grids";
import { useEffect, useRef } from "react";
import LoadingIndicator from "../pages/LoadingIndicator";

const CartListTable = ({
  CartList,
  imagePerm,
  type,
  handleChange,
  handleDelete,
  handleToggle,
  handleTotals,
  handleSystem,
  loading,
  viewOnly = false,
}) => {
  const gridRef = useRef(null);

  function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  }

  // const formatCurrency = (number) => {
  //   return number.toLocaleString("en-US", {
  //     style: "currency",
  //     currency: "USD",
  //     minimumFractionDigits: 2,
  //   });
  // };

  const PartGridactiveStatus = (props) => (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {imagePerm && (props.image || props.image_url) && (
        <div
          className="image flex gap-4"
          style={{ maxWidth: "72px", height: "72px", flex: "0 0 20%" }}
        >
          <img
            className="rounded-xl"
            src={
              props.image_url
                ? `${props.image_url}`
                : `data:image/jpeg;base64,${props.image}`
            }
            alt={`Part ${props.part_number}`}
          />
        </div>
      )}
      <div
        style={{
          flex:
            imagePerm && (props.image || props.image_url)
              ? "0 0 80%"
              : "0 0 100%",
          paddingTop: !(imagePerm && (props.image || props.image_url)) && "2px",
          paddingBottom:
            !(imagePerm && (props.image || props.image_url)) && "2px",
          alignSelf: "center",
        }}
      >
        <div style={{ fontWeight: "bold", textAlign: "center" }}>
          {props.part_number}
        </div>
        <div className="text-center text-xs text-wrap">
          {truncate(
            props.details,
            imagePerm && (props.image || props.image_url) ? 78 : 88,
          )}
        </div>
      </div>
    </div>
  );

  const quotCols = [
    {
      field: "part_number",
      template: PartGridactiveStatus,
      headerText: "PART",
      minWidth: "280",
      width: "320",
      maxWidth: "420",
      textAlign: "center",
      allowEditing: false,
      isPrimaryKey: true,
    },
    {
      field: "unit",
      headerText: "UNIT",
      minWidth: "65",
      width: "65",
      maxWidth: "70",
      textAlign: "center",
      allowEditing: false,
    },
    {
      field: "quantity",
      headerText: "QTY",
      minWidth: "65",
      width: "65",
      maxWidth: "70",
      textAlign: "center",
      allowEditing: !viewOnly,
      type: "number", // 👈 IMPORTANT
      editType: "numericedit", // 👈 IMPORTANT
      format: "N0", // 2 decimal places (optional)
      edit: {
        params: {
          decimals: 0, // how many decimal places allowed
          min: 0, // prevent negative qty
          step: 1, // increment step
        },
      },
    },
    {
      field: "unit_price",
      headerText: "PRICE",
      minWidth: "70",
      width: "70",
      maxWidth: "75",
      textAlign: "center",
      allowEditing: !viewOnly,
      type: "number", // 👈 IMPORTANT
      editType: "numericedit", // 👈 IMPORTANT
      format: "N2", // 2 decimal places (optional)
      edit: {
        params: {
          decimals: 2, // how many decimal places allowed
          min: 0, // prevent negative qty
          step: 1, // increment step
        },
      },
    },
    {
      field: "total",
      headerText: "TOTAL",
      minWidth: "75",
      width: "75",
      maxWidth: "85",
      format: "c2",
      textAlign: "center",
      allowEditing: false,
    },
    {
      field: "req_date",
      headerText: "REQ DATE",
      minWidth: "85",
      width: "85",
      maxWidth: "90",
      textAlign: "center",
      allowEditing: !viewOnly,
      editType: "datepickeredit", // 👈 IMPORTANT
      format: "d/M/y", // display format
      type: "date", // 👈 IMPORTANT
    },
    {
      field: "notes",
      headerText: "ITEM NOTE",
      minWidth: "180",
      width: "190",
      maxWidth: "420",
      allowEditing: !viewOnly,
      textAlign: "center",
    },
    !viewOnly
      ? {
          headerText: "",
          width: "60",
          textAlign: "Center",
          allowEditing: false,
          template: (props) => (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(
                  String(props.part_id) + props.details + props.notes,
                );
              }}
            >
              ❌
            </button>
          ),
        }
      : {
          headerText: "",
          width: "10",
          textAlign: "Center",
          allowEditing: false,
        },
  ];

  const saleCols = [
    {
      field: "part_number",
      template: PartGridactiveStatus,
      headerText: "PART",
      minWidth: "280",
      width: "320",
      maxWidth: "420",
      textAlign: "center",
      allowEditing: false,
      isPrimaryKey: true,
    },
    {
      field: "unit",
      headerText: "UNIT",
      minWidth: "65",
      width: "65",
      maxWidth: "70",
      textAlign: "center",
      allowEditing: false,
    },
    {
      field: "quantity",
      headerText: "QTY",
      minWidth: "65",
      width: "65",
      maxWidth: "70",
      textAlign: "center",
      allowEditing: !viewOnly,
      type: "number", // 👈 IMPORTANT
      editType: "numericedit", // 👈 IMPORTANT
      format: "N0", // 2 decimal places (optional)
      edit: {
        params: {
          decimals: 0, // how many decimal places allowed
          min: 0, // prevent negative qty
          step: 1, // increment step
        },
      },
    },
    {
      field: "unit_price",
      headerText: "PRICE",
      minWidth: "70",
      width: "70",
      maxWidth: "75",
      textAlign: "center",
      allowEditing: !viewOnly,
      type: "number", // 👈 IMPORTANT
      editType: "numericedit", // 👈 IMPORTANT
      format: "N2", // 2 decimal places (optional)
      edit: {
        params: {
          decimals: 2, // how many decimal places allowed
          min: 0, // prevent negative qty
          step: 1, // increment step
        },
      },
    },
    {
      field: "total",
      headerText: "TOTAL",
      minWidth: "75",
      width: "75",
      maxWidth: "85",
      format: "c2",
      textAlign: "center",
      allowEditing: false,
    },
    {
      field: "req_date",
      headerText: "REQ DATE",
      minWidth: "85",
      width: "85",
      maxWidth: "90",
      textAlign: "center",
      editType: "datepickeredit", // 👈 IMPORTANT
      format: "d/M/y", // display format
      type: "date", // 👈 IMPORTANT
    },
    {
      field: "shipment",
      headerText: "SHIP QTY",
      minWidth: "75",
      width: "75",
      maxWidth: "80",
      textAlign: "center",
      type: "number", // 👈 IMPORTANT
      editType: "numericedit", // 👈 IMPORTANT
      format: "N0", // 2 decimal places (optional)
      edit: {
        params: {
          decimals: 0, // how many decimal places allowed
          min: 0, // prevent negative qty
          step: 1, // increment step
        },
      },
    },
    {
      field: "ship_date",
      headerText: "SHIP DATE",
      minWidth: "80",
      width: "85",
      maxWidth: "90",
      textAlign: "center",
      editType: "datepickeredit", // 👈 IMPORTANT
      format: "d/M/y", // display format
      type: "date", // 👈 IMPORTANT
    },
    {
      field: "notes",
      headerText: "ITEM NOTE",
      minWidth: "180",
      width: "190",
      maxWidth: "420",
      textAlign: "center",
    },
    {
      field: "system_check",
      headerText: "SYS",
      width: "50",
      textAlign: "Center",
      editType: "booleanedit", // 👈 IMPORTANT
      type: "boolean", // 👈 IMPORTANT
      displayAsCheckBox: true,
    },
    !viewOnly
      ? {
          headerText: "",
          width: "50",
          textAlign: "Center",
          allowEditing: false,
          template: (props) => (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(
                  String(props.part_id) + props.details + props.notes,
                );
              }}
            >
              ❌
            </button>
          ),
        }
      : {
          headerText: "",
          width: "60",
          textAlign: "Center",
          allowEditing: false,
          template: (props) => (
            <button
              onClick={(e) => handleSystem(props)}
              disabled={props.system_status === 0}
              style={{ color: "navy", fontWeight: "bold" }}
            >
              {props.system_status === 0
                ? ""
                : props.system_status === 1
                  ? "Create System"
                  : "Edit System"}
            </button>
          ),
        },
  ];

  const purcCols = [
    {
      field: "part_number",
      template: PartGridactiveStatus,
      headerText: "PART",
      minWidth: "280",
      width: "320",
      maxWidth: "420",
      textAlign: "center",
      allowEditing: false,
      isPrimaryKey: true,
    },
    {
      field: "unit",
      headerText: "UNIT",
      minWidth: "65",
      width: "65",
      maxWidth: "70",
      textAlign: "center",
      allowEditing: false,
    },
    {
      field: "quantity",
      headerText: "QTY",
      minWidth: "65",
      width: "65",
      maxWidth: "70",
      textAlign: "center",
      allowEditing: !viewOnly,
      type: "number", // 👈 IMPORTANT
      editType: "numericedit", // 👈 IMPORTANT
      format: "N0", // 2 decimal places (optional)
      edit: {
        params: {
          decimals: 0, // how many decimal places allowed
          min: 0, // prevent negative qty
          step: 1, // increment step
        },
      },
    },
    {
      field: "unit_price",
      headerText: "PRICE",
      minWidth: "70",
      width: "70",
      maxWidth: "75",
      textAlign: "center",
      allowEditing: !viewOnly,
      type: "number", // 👈 IMPORTANT
      editType: "numericedit", // 👈 IMPORTANT
      format: "N2", // 2 decimal places (optional)
      edit: {
        params: {
          decimals: 2, // how many decimal places allowed
          min: 0, // prevent negative qty
          step: 1, // increment step
        },
      },
    },
    {
      field: "total",
      headerText: "TOTAL",
      minWidth: "75",
      width: "75",
      maxWidth: "85",
      format: "c2",
      textAlign: "right",
      allowEditing: false,
    },
    {
      field: "expected_date",
      headerText: "EXPC DATE",
      minWidth: "85",
      width: "85",
      maxWidth: "90",
      textAlign: "center",
      allowEditing: !viewOnly,
      editType: "datepickeredit", // 👈 IMPORTANT
      format: "d/M/y", // display format
      type: "date", // 👈 IMPORTANT
    },
    {
      field: "received_qty",
      headerText: "RECV QTY",
      minWidth: "75",
      width: "75",
      maxWidth: "80",
      textAlign: "center",
      allowEditing: false,
    },
    {
      field: "mfg_name",
      headerText: "MFG NAME",
      minWidth: "75",
      width: "75",
      maxWidth: "100",
      textAlign: "center",
      allowEditing: false,
    },
    {
      field: "mfg_pn",
      headerText: "MFG PN",
      minWidth: "70",
      width: "70",
      maxWidth: "100",
      textAlign: "center",
      allowEditing: false,
    },
    {
      field: "notes",
      headerText: "ITEM NOTE",
      minWidth: "180",
      width: "190",
      maxWidth: "420",
      textAlign: "center",
      allowEditing: !viewOnly,
    },
    !viewOnly
      ? {
          headerText: "",
          width: "60",
          textAlign: "Center",
          allowEditing: false,
          template: (props) => (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(
                  String(props.part_id) + props.details + props.notes,
                );
              }}
            >
              ❌
            </button>
          ),
        }
      : {
          headerText: "",
          width: "10",
          textAlign: "Center",
          allowEditing: false,
        },
  ];

  const handleActionBegin = (args) => {
    if (args.requestType === "save") {
      const row = args.data;
      row.total = (Number(row.quantity) || 0) * (Number(row.unit_price) || 0);
    }
  };

  const handleActionComplete = (args) => {
    if (args.requestType === "save") {
      handleTotals();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const grid = gridRef.current;
      if (!grid) return;

      const gridElement = grid.element;
      if (!gridElement.contains(event.target)) {
        const isPopup = document.querySelector(".e-popup-open");
        if (grid.isEdit && !isPopup) {
          grid.endEdit(); // ✅ auto save
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="m-0 p-0">
      {loading ? (
        <LoadingIndicator />
      ) : (
        <GridComponent
          ref={gridRef}
          className="custom-grid2"
          dataSource={CartList}
          // height="calc(62vh - 60px)"
          // allowSorting
          allowResizing
          // allowEditing
          // toolbar={["Search"]}
          // rowSelected={handleRowSelected}
          recordDoubleClick={(item) => handleToggle(item)}
          // rowHeight={64}
          editSettings={{ allowEditing: !viewOnly, mode: "Normal" }}
          allowRowDragAndDrop={!CartList.some((item) => item.received_qty > 0)}
          actionBegin={handleActionBegin}
          actionComplete={handleActionComplete}
          // rowDrop={onRowDrop}
        >
          <ColumnsDirective>
            {type === "purchase"
              ? purcCols.map((item, index) => (
                  <ColumnDirective key={index} {...item} />
                ))
              : type === "sale"
                ? saleCols.map((item, index) => (
                    <ColumnDirective key={index} {...item} />
                  ))
                : quotCols.map((item, index) => (
                    <ColumnDirective key={index} {...item} />
                  ))}
          </ColumnsDirective>
          <Inject services={[Resize, Sort, Page, Edit, Toolbar, RowDD]} />
        </GridComponent>
      )}
      {/* <table className="table table-striped table-bordered">
        <thead>
          <tr className="table-sale-tr">
            <th style={{ width: "280px" }}>PART</th>
            <th style={{ width: "60px" }}>UNIT</th>
            <th style={{ width: "65px" }}>QTY</th>
            <th style={{ width: "80px" }}>PRICE</th>
            <th style={{ width: "75px" }}>TOTAL</th>
            {(type === "sale" || type === "quote") && (
              <th style={{ width: "110px" }}>REQ DATE</th>
            )}
            {type === "sale" && <th style={{ width: "70px" }}>SHIP QTY</th>}
            {type === "sale" && <th style={{ width: "110px" }}>SHIP DATE</th>}
            {type === "purchase" && (
              <th style={{ width: "110px" }}>EXPC DATE</th>
            )}
            {type === "purchase" && <th style={{ width: "70px" }}>RECV QTY</th>}
            {type === "purchase" && <th style={{ width: "90px" }}>MFG NAME</th>}
            {type === "purchase" && <th style={{ width: "70px" }}>MFG PN</th>}
            <th style={{ width: "180px" }}>ITEM NOTES</th>
            {!viewOnly && <th style={{ width: "35px" }}>DEL</th>}
          </tr>
        </thead>
        {!viewOnly ? (
          <tbody className="pos-table-body">
            {CartList?.map((item, index) => (
              <tr key={index}>
                <td onClick={() => handleToggle(item)}>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {imagePerm && (item.image || item.image_url) && (
                      <div
                        className="image flex gap-4"
                        style={{
                          maxWidth: "72px",
                          height: "64px",
                          flex: "0 0 20%",
                        }}
                      >
                        <img
                          className="rounded-xl"
                          src={
                            item.image_url
                              ? `${item.image_url}`
                              : `data:image/jpeg;base64,${item.image}`
                          }
                          alt={`Part ${item.code}`}
                        />
                      </div>
                    )}
                    <div
                      style={{
                        flex:
                          imagePerm && (item.image || item.image_url)
                            ? "0 0 80%"
                            : "0 0 100%",
                        paddingTop:
                          !(imagePerm && (item.image || item.image_url)) &&
                          "8px",
                        paddingBottom:
                          !(imagePerm && (item.image || item.image_url)) &&
                          "7px",
                        alignSelf: "center",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>
                        {item.part_number}
                      </div>
                      <div>
                        {truncate(
                          item.details,
                          imagePerm && (item.image || item.image_url) ? 78 : 88,
                        )}
                      </div>
                    </div>
                  </div>
                </td>
                <td>{item.unit}</td>
                <td>
                  <div className="centered-input">
                    <input
                      className="input"
                      name="quantity"
                      id="quantity"
                      type="number"
                      step="1.00"
                      min="0"
                      data-index={index}
                      value={item.quantity}
                      onChange={handleChange}
                    />
                  </div>
                </td>
                <td>
                  <div className="centered-input">
                    <input
                      className="input"
                      name="unit_price"
                      id="unit_price"
                      type="number"
                      step="1.00"
                      min="0"
                      data-index={index}
                      value={item.unit_price}
                      onChange={handleChange}
                    />
                  </div>
                </td>
                <td>{formatCurrency(item.total)}</td>
                {(type === "sale" || type === "quote") && (
                  <td>
                    <div className="centered-input">
                      <input
                        className="input"
                        name="req_date"
                        id="req_date"
                        type="date"
                        data-index={index}
                        value={item.req_date}
                        onChange={handleChange}
                      />
                    </div>
                  </td>
                )}
                {type === "sale" && (
                  <td>
                    <div className="centered-input">
                      <input
                        className="input"
                        name="shipment"
                        id="shipment"
                        type="number"
                        step="1.00"
                        min="0"
                        data-index={index}
                        value={item.shipment}
                        onChange={handleChange}
                      />
                    </div>
                  </td>
                )}
                {type === "sale" && (
                  <td>
                    <div className="centered-input">
                      <input
                        className="input"
                        name="ship_date"
                        id="ship_date"
                        type="date"
                        data-index={index}
                        value={item.ship_date}
                        onChange={handleChange}
                      />
                    </div>
                  </td>
                )}
                {type === "purchase" && (
                  <td>
                    <div className="centered-input">
                      <input
                        className="input"
                        name="expected_date"
                        id="expected_date"
                        type="date"
                        data-index={index}
                        value={item.expected_date}
                        onChange={handleChange}
                      />
                    </div>
                  </td>
                )}
                {type === "purchase" && <td>{item.received_qty || 0}</td>}
                {type === "purchase" && <td>{item.mfg_name || "-"}</td>}
                {type === "purchase" && <td>{item.mfg_pn || "-"}</td>}
                <td>
                  <div className="centered-input">
                    <textarea
                      className="textarea"
                      name="notes"
                      id="notes"
                      type="text"
                      maxLength={250}
                      data-index={index}
                      value={item.notes}
                      onChange={handleChange}
                    />
                  </div>
                </td>
                <td>
                  <button onClick={() => handleDelete(index)}>❌</button>
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody className="pos-table-body">
            {CartList?.map((item, index) => (
              <tr key={index}>
                <td onClick={() => handleToggle(item)}>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {imagePerm && (item.image || item.image_url) && (
                      <div
                        className="image flex gap-4"
                        style={{
                          maxWidth: "72px",
                          height: "72px",
                          flex: "0 0 20%",
                        }}
                      >
                        <img
                          className="rounded-xl"
                          src={
                            item.image_url
                              ? `${item.image_url}`
                              : `data:image/jpeg;base64,${item.image}`
                          }
                          alt={`Part ${item.code}`}
                        />
                      </div>
                    )}
                    <div
                      style={{
                        flex:
                          imagePerm && (item.image || item.image_url)
                            ? "0 0 80%"
                            : "0 0 100%",
                        paddingTop:
                          !(imagePerm && (item.image || item.image_url)) &&
                          "8px",
                        paddingBottom:
                          !(imagePerm && (item.image || item.image_url)) &&
                          "7px",
                        alignSelf: "center",
                      }}
                    >
                      <div style={{ fontWeight: "bold" }}>
                        {item.part_number}
                      </div>
                      <div>
                        {truncate(
                          item.details,
                          imagePerm && (item.image || item.image_url) ? 78 : 88,
                        )}
                      </div>
                    </div>
                  </div>
                </td>
                <td>{item.unit || `-`}</td>
                <td>{item.quantity}</td>
                <td>{formatCurrency(item.unit_price)}</td>
                <td>{formatCurrency(item.total)}</td>
                {(type === "sale" || type === "quote") && (
                  <td>{item.req_date || `-`}</td>
                )}
                {type === "sale" && <td>{item.shipment || `-`}</td>}
                {type === "sale" && <td>{item.ship_date || `-`}</td>}
                {type === "purchase" && <td>{item.expected_date || `-`}</td>}
                {type === "purchase" && <td>{item.received_qty || 0}</td>}
                {type === "purchase" && <td>{item.mfg_name || "-"}</td>}
                {type === "purchase" && <td>{item.mfg_pn || "-"}</td>}
                <td style={{ whiteSpace: "pre-line" }}>{item.notes || `-`}</td>
              </tr>
            ))}
          </tbody>
        )}
      </table> */}
    </div>
  );
};

export default CartListTable;
